import classnames from 'classnames';
import { Heading } from 'yoso';
import { BaseCard, BaseCardProps } from '~/components/Card';
import { CategoryAdditionalInfoValue } from '~/components/Help/Help.helpers';
import { HelpCategoryModel } from '~/components/Help/Help.hooks';
import './HelpCategoryCard.scss';

export type HelpCategoryCardProps = HelpCategoryModel & Partial<CategoryAdditionalInfoValue>;

export const HelpCategoryCard = ({ title, color, description, figure }: HelpCategoryCardProps) => (
  <BaseCard
    className={classnames('help-category-card')}
    size="small"
    color={color as BaseCardProps['color']}
    shadow>
    <div className="card-header">
      <img src={figure} alt={title} />
    </div>
    <div className="card-body">
      <Heading level={5}>
        {title}
        {description && <small>{description}</small>}
      </Heading>
    </div>
  </BaseCard>
);
